module.exports = __webpack_public_path__ + "h5/img/cygn12.6281fd56.png";